<template>
	<div>
		<div class="match">
			<div class="wrapper">
				<div class="match_row">
					<tournaments v-if="info.sport" :type="info.sport"></tournaments>
					
					<div class="match_right">
						<div class="tab">
							<match-header></match-header>
							
							<tournament-header></tournament-header>
							
							<div class="tab_content">
								<div class="tab_block active" id="block-1">
									<matches v-if="finishedMatches" :type="info.sport" :list="finishedMatches" :show-title="false"></matches>
									<div class="info-text" style="padding-top: 10px;" v-else>Загрузка...</div>
								</div>
								<div class="tab_block" id="block-2">
									<matches :type="info.sport" :show-date="true" :list="notStartedMatches" :show-title="false"></matches>
								</div>
								<div class="tab_block __margin" id="block-3">
									<standings :data="standings"></standings>
								</div>
								<div class="tab_block" id="block-4">
									<div class="winners">
										<div class="winners_row">
											<div class="winners_col">
												<div class="winners_heading">Сезон</div>
											</div>
											<div class="winners_col">
												<div class="winners_heading">Чемпион</div>
											</div>
										</div>
										<div class="winners_row">
											<div class="winners_col">
												<div class="winners_content">
													<a href="" class="winners_link">Премьер-лига 2019/2020</a>
												</div>
											</div>
											<div class="winners_col">
												<div class="winners_content">
													<i class="flag fra"></i>
													<span>
														<a href="" class="winners_link">Манчестер Сити</a>
													</span>
												</div>
											</div>
										</div>
										<div class="winners_row">
											<div class="winners_col">
												<div class="winners_content">
													<a href="" class="winners_link">Премьер-лига 2019/2020</a>
												</div>
											</div>
											<div class="winners_col">
												<div class="winners_content">
													<i class="flag fra"></i>
													<span>
														<a href="" class="winners_link">Манчестер Сити</a>
													</span>
												</div>
											</div>
										</div>
										<div class="winners_row">
											<div class="winners_col">
												<div class="winners_content">
													<a href="" class="winners_link">Премьер-лига 2019/2020</a>
												</div>
											</div>
											<div class="winners_col">
												<div class="winners_content">
													<i class="flag fra"></i>
													<span>
														<a href="" class="winners_link">Манчестер Сити</a>
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
								
								<div class="tab_block" id="block-5">
									<scorers :data="scorers"></scorers>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Tournaments from "../components/Tournaments/Tournaments";
	import MatchHeader from "../components/Match/MatchHeader";
	import TournamentHeader from "../components/Tournaments/TournamentHeader";
	import Matches from "../components/Match/Matches";
	import Standings from "../components/Standings/Standings";
	import Scorers from "../components/Scorers/Scorers";
	
	export default {
		components: {
			Standings,
			Tournaments,
			MatchHeader,
			TournamentHeader,
			Matches,
			Scorers
		},
		
		data() {
			return {
				info: {},
				type: this.$route.params.id,
				finishedMatches: null,
				notStartedMatches: {},
			}
		},
		
		computed: {
			standings() {
				return this.info.standings || [];
			},
			scorers() {
				return this.info.topscorer;
			}
		},
		
		created() {
			this.axios.get('/api/events?status=finished&order=startdate&tournament_id=' + this.$route.params.id)
				.then(({data}) => {
					this.finishedMatches = data;
				});
			
			this.axios.get('/api/events?tournament_id=' + this.$route.params.id + '&status=notstarted')
				.then(({data}) => {
					this.notStartedMatches = data;
				});
			
			this.axios.get('/api/tournaments/' + this.$route.params.id)
				.then(({data}) => {
					this.info = data;
				});
		},
		
		mounted() {
			
		},
		
		methods: {
			
		}
	}
</script>